export default "__VITE_ASSET__BOmtwsd1__"